import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';

import { Row, Icon } from 'yurstrap';
import { extractQueryParameters } from 'helpers/RoutesHelpers';

import {
    initCMPApp,
    openModal,
} from './reduxModules/ConsentManagementPlatform';

import CMPModal from './components/CMPModal';
import CMPBanner from './components/CMPBanner';
import CMPBannerPortal from './components/CMPBannerPortal';
import CMPFacebookPortal from './components/CMPFacebookPortal';

import { getScopeSelector } from '../commons/reduxModules/Authentication';
import Scopes from '../constants/Scopes';

const propTypes = {
    AppActions: PropTypes.shape({
        initCMPApp: PropTypes.func.isRequired,
        openModal: PropTypes.func.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
    scope: PropTypes.string.isRequired,
};

class CMPModalPortal extends Component {

    constructor(props) {
        super(props);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.element = document.createElement('div');
        this.appSelector = '#js-app-cmp';
        this.portalRoot = document.querySelector(this.appSelector);
    }

    componentDidMount() {
        const { AppActions } = this.props;
        AppActions.initCMPApp();
        this.portalRoot.appendChild(this.element);
    }

    componentWillUnmount() {
        this.portalRoot.removeChild(this.element);
    }

    onOpenModal() {
        const { AppActions } = this.props;
        AppActions.openModal();
    }

    renderSubPortals() {
        const { scope } = this.props;
        if (Scopes.USER === scope) return <CMPBanner />;
        return (
            <>
                <CMPBannerPortal />
                <CMPFacebookPortal />
            </>
        );
    }

    renderMenuItem() {
        const { scope } = this.props;
        if (Scopes.USER === scope) return null;
        return (
            <a
                className="c-dashboard-header__dropdown--subitem"
                onClick={this.onOpenModal}
            >
                <Row vbottom noCol>
                    <Icon
                        collection="yp"
                        icon="options"
                        className="u-font-size--6 u-color__grey--60 pr-2"
                        aria-hidden="true"
                    />
                    <span
                        className="c-type-body--2 u-color__grey--60"
                    >
                        Gestion des cookies
                    </span>
                </Row>
            </a>
        );
    }

    renderPortalContent() {
        const { history } = this.props;
        const CMPModalLocation = {
            pathname: '',
            search: '',
            hash: '',
        };
        if (history && history.location) {
            CMPModalLocation.pathname = extractQueryParameters(history.location.search)['cmp-modal'] || '';
        }
        return (
            <>
                <CMPModal location={CMPModalLocation} />
                {this.renderMenuItem()}
                {this.renderSubPortals()}
            </>
        );
    }

    render() {
        return ReactDOM.createPortal(
            this.renderPortalContent(),
            this.element,
        );
    }

}

CMPModalPortal.propTypes = propTypes;

function mapStateToProps(state) {
    return {
        scope: getScopeSelector(state),
    };
}

const ConnectedApp = withRouter(
    connect(mapStateToProps, (dispatch) => ({
        AppActions: bindActionCreators({
            initCMPApp,
            openModal,
        }, dispatch),
    }))(CMPModalPortal),
);

export default ConnectedApp;
